import { PrecedentMapControlsModel } from "../models/precedent-map-controls";
import { backboneViewProperties } from "../../decorators/backbone-properties";

const template = require<string>("../../precedent-map/views/precedent-map-controls.html");

@backboneViewProperties({template})
export class PrecedentMapControlsView extends Marionette.ItemView<PrecedentMapControlsModel> {

    constructor(public model: PrecedentMapControlsModel) {
        super();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click #pmap-back"] = "backButtonClick";
        events["click #pmap-forward"] = "forwardButtonClick";
        events["click #pmap-close"] = "closeButtonClick";
        events["click .display-option"] = "displayOptionClick";
        return events;
    }

    public onShow() {
        this.setupModelListeners();
    }

    private setupModelListeners() {
        this.listenTo(this.model, "change:Engaged", this.engagedChanged);
        this.listenTo(this.model, "change:BackEnabled", this.backEnabled);
        this.listenTo(this.model, "change:ForwardEnabled", this.forwardEnabled);
        this.listenTo(this.model, "change:DisplayTypes", this.displayTypesChanged);
    }

    private engagedChanged(model, prop) {
        this.$("#precedent-map-controls").toggleClass("engaged", prop);
    }

    private backEnabled(model, prop) {
        this.$("#pmap-back").toggleClass("disabled", !prop);
    }

    private forwardEnabled(model, prop) {
        this.$("#pmap-forward").toggleClass("disabled", !prop);
    }

    private displayOptionClick(e: JQueryEventObject) {
        const types = [];
        this.$(".display-option").each((idx, chk) => {
            if ($(chk).prop("checked")) {
                const relationType = parseInt($(chk).attr("data-type"));
                types.push(relationType);
            }
        });
        this.model.setDisplayTypes(types, false);
    }

    private forwardButtonClick(e: JQueryEventObject) {
        if ($(e.currentTarget).hasClass("disabled")) {
             return;
        }
        window.history.forward();
    }

    private backButtonClick(e: JQueryEventObject) {
        if ($(e.currentTarget).hasClass("disabled")) {
            return;
        }
        window.history.back();
    }

    private closeButtonClick() {
        Backbone.history.navigate(this.model.get("ExitUrl"), true);
    }

    private displayTypesChanged(model, prop) {
        this.$(".display-option").prop("checked", false);
        for (const p of prop) {
            this.$(".display-option[data-type='" + p + "']").prop("checked", true);
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/precedent-map/views/precedent-map-controls.ts